/**
 * Toggle Price Rates
 * @function togglePriceRates
 * @param {event} e 
 */
window.togglePriceRates = function (e) {
    e.stopPropagation();

    let planToggle = e.target;
    let fadedClass = 'faded';
    let offClass = 'toggled-off';

    let toggleContainer = planToggle.parentNode.parentNode.parentNode.parentNode;

    let monthlyViews = toggleContainer.querySelectorAll('.monthly');
    let yearlyViews = toggleContainer.querySelectorAll('.yearly');
    let toggleLabel = toggleContainer.parentNode.querySelectorAll('.bill-label');
    let toggleSwitch = toggleContainer.querySelectorAll('.switch');
    let toggleBox = toggleContainer.parentNode.querySelector('.switch > input');

    //  toggle switch if we're in that context
    if (toggleSwitch.length == 0) {
        if (toggleBox.checked == true) {
            toggleBox.checked = false;
        } else {
            toggleBox.checked = true;
        }
    }

    //  toggle label class
    if (toggleLabel[0].classList.contains(fadedClass)) {
        toggleLabel[0].classList.remove(fadedClass);
        toggleLabel[1].classList.add(fadedClass);
    } else {
        toggleLabel[0].classList.add(fadedClass);
        toggleLabel[1].classList.remove(fadedClass);
    }

    //  toggle monthly and yearly elements
    if (monthlyViews[0].classList.contains(offClass)) {
        monthlyViews.forEach(function (monthly) {
            monthly.classList.remove(offClass);
        });

        yearlyViews.forEach(function (yearly) {
            yearly.classList.add(offClass);
        });
    } else {
        monthlyViews.forEach(function (monthly) {
            monthly.classList.add(offClass);
        });

        yearlyViews.forEach(function (yearly) {
            yearly.classList.remove(offClass);
        });
    }
};